import { render, staticRenderFns } from "./ConfirmCancelReferenceBookDialog.vue?vue&type=template&id=70c15e8c&"
import script from "./ConfirmCancelReferenceBookDialog.vue?vue&type=script&lang=js&"
export * from "./ConfirmCancelReferenceBookDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/isaiahlarsen/Code/user-dashboard-3/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VCardTitle,VDialog,VIcon,VLayout,VSnackbar})
